import { AdminService } from 'src/app/services/admin.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import * as jquery from 'jquery';

@Component({
  selector: 'app-push-notifications',
  templateUrl: './push-notifications.component.html',
  styleUrls: ['./push-notifications.component.scss']
})
export class PushNotificationsComponent implements OnInit {

  submitted = false;
  error = false;
  notificationForm: FormGroup;
  submitSuccess = false;
  disableSubmit = false;
  noticationTextMaxLength = 250;
  modalText = 'Sending...';

  constructor(
    private adminService: AdminService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.setFormControls();
  }

  private setFormControls(): void {
    this.notificationForm = this.fb.group({
      labelText: ['', {
        validators: [Validators.required,
          Validators.minLength(5),
        ]
      }],
      notificationText: ['', {
        validators: [Validators.required,
          Validators.minLength(5),
          Validators.maxLength(this.noticationTextMaxLength)
        ]
      }],
    });

  }

  // Convenience getter for easy access to form fields
  get f() { return this.notificationForm.controls; }

  onSubmit() {
    this.submitted = true;

    // Stop here if there's form errors
    if (this.notificationForm.invalid) {
      return;
    }

    this.showProgressModal();
    this.disableSubmit = true;

    this.adminService.sendNotification(this.f.labelText.value, this.f.notificationText.value)
      .subscribe(
        response => {
          this.hideProgressModal();

          this.submitSuccess = true;

          setTimeout(() => {
            this.submitSuccess = false;
            this.submitted = false;
            this.disableSubmit = false;
            this.notificationForm.reset();
            this.f.notificationText.setValue('');
            this.f.notificationText.clearValidators();
          }, 2000);
        },
        error => {
          this.error = true;

          setTimeout(() => {
            this.error = false;
            this.submitted = false;
            this.disableSubmit = false;
          }, 2000);

          this.hideProgressModal();
        });

  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
